// utils/validateForPricing.js
export function validateForPricing(state) {
  const errs = [];
  const { customer = {}, fulfillment = {} } = state || {};

  // Customer
  if (!customer.firstName?.trim())
    errs.push({ code: "FIRST_NAME_REQUIRED", field: "customer.firstName" });
  if (!customer.lastName?.trim())
    errs.push({ code: "LAST_NAME_REQUIRED", field: "customer.lastName" });
  if (!customer.email?.trim())
    errs.push({ code: "EMAIL_REQUIRED", field: "customer.email" });

  // Date is always required
  const date = fulfillment?.scheduledDate?.trim();
  if (!date)
    errs.push({ code: "DATE_REQUIRED", field: "fulfillment.scheduledDate" });

  // Address requirement: delivery OR setup ⇒ need confirmed address
  const needsAddress =
    fulfillment?.method === "delivery" || !!fulfillment?.setupSelected;
  if (needsAddress) {
    const a = fulfillment?.address || {};
    const hasLine1 = !!a.line1?.trim();
    const km = Number(a.distanceKm || 0);
    const hasKm = Number.isFinite(km) && km > 0;

    if (!hasLine1 || !hasKm) {
      errs.push({ code: "ADDRESS_REQUIRED", field: "fulfillment.address" });
    }
  }

  return { ok: errs.length === 0, errs };
}
